import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed, ref, watch, onMounted, onUnmounted } from 'vue';
  import { Carousel, Navigation, Pagination as Page, Slide } from 'vue3-carousel';
  import 'vue3-carousel/dist/carousel.css';
  import HomeTestimonyCarouselSlide from './HomeTestimonyCarouselSlide.vue';
  import { useI18n } from 'vue-i18n';
  import img1 from '@/assets/girl-1.jpg';
  import img2 from '@/assets/guy-1.jpg';
  import img3 from '@/assets/girl-2.jpg';
  import img4 from '@/assets/guy-2.jpg';
  import img5 from '@/assets/girl-3.jpg';
  import img6 from '@/assets/guy-3.jpg';
  export interface TestimonyQutoes {
    image: string;
    name: string;
    title: string;
    quote: string;
    business: string;
    position: string;
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeTestimonyCarousel',
  props: {
    extendedCarousel: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

  
  const { tm, rt, t, te } = useI18n({ useScope: 'global' });
  const mokedImages = [img1, img2, img3, img4, img5, img6];
  const windowWidth = ref(window.innerWidth);
  const onWidthChange = () => (windowWidth.value = window.innerWidth);
  onMounted(() => window.addEventListener('resize', onWidthChange));
  onUnmounted(() => window.removeEventListener('resize', onWidthChange));
  const width = computed(() => windowWidth.value);
  const { extendedCarousel } = toRefs(props);
  const myCarousel = ref(null);
  const itemsToShow = computed(() => {
    return extendedCarousel.value || width.value < 1024 ? 1 : 1.5;
  });
  watch(extendedCarousel, () => {
    myCarousel.value.next();
    const interval = setInterval(() => {
      myCarousel.value.updateSlideWidth();
    }, 30);
    setTimeout(() => {
      clearInterval(interval);
    }, 1000);
  });

  //Must have 9 items
  const list = computed(() => tm('Testimony.testimonies'));

const __returned__ = { props, tm, rt, t, te, mokedImages, windowWidth, onWidthChange, width, extendedCarousel, myCarousel, itemsToShow, list, toRefs, computed, ref, watch, onMounted, onUnmounted, get Carousel() { return Carousel }, get Navigation() { return Navigation }, get Page() { return Page }, get Slide() { return Slide }, HomeTestimonyCarouselSlide, get useI18n() { return useI18n }, get img1() { return img1 }, get img2() { return img2 }, get img3() { return img3 }, get img4() { return img4 }, get img5() { return img5 }, get img6() { return img6 } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})